var _defs, _g, _g2, _circle, _circle2, _circle3, _g3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNoOptions = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nooptions",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill-gradient",
    x1: 0.653,
    y1: 2.203,
    x2: 0.34,
    y2: -1.046,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8cadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9399b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35053",
    "data-name": "Group 35053"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7041",
    "data-name": "Ellipse 7041",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#eaeaf3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35055",
    "data-name": "Group 35055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35054",
    "data-name": "Group 35054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63243",
    "data-name": "Path 63243",
    d: "M16.1,55.5a1.58,1.58,0,0,1-1.6-1.6V19.5h41V53.9a1.58,1.58,0,0,1-1.6,1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63244",
    "data-name": "Path 63244",
    d: "M55,20V53.9A1.11,1.11,0,0,1,53.9,55H16.1A1.11,1.11,0,0,1,15,53.9V20H55m1-1H14V53.9A2.051,2.051,0,0,0,16.1,56H53.9A2.112,2.112,0,0,0,56,53.9V19Z",
    fill: "#b2b6cc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_63245",
    "data-name": "Path 63245",
    d: "M53.9,13H16.1A2.163,2.163,0,0,0,14,15.3V20H56V15.3A2.163,2.163,0,0,0,53.9,13Z",
    fill: "url(#fill-gradient)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7042",
    "data-name": "Ellipse 7042",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(16 15)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7043",
    "data-name": "Ellipse 7043",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(21 15)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7044",
    "data-name": "Ellipse 7044",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(26 15)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35057",
    "data-name": "Group 35057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35056",
    "data-name": "Group 35056"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7045",
    "data-name": "Ellipse 7045",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(27 26)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63246",
    "data-name": "Path 63246",
    d: "M36,27a8,8,0,1,1-8,8,8.024,8.024,0,0,1,8-8m0-2A10,10,0,1,0,46,35,10.029,10.029,0,0,0,36,25Z",
    fill: "#9399b5"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1001",
    "data-name": "Line 1001",
    x1: 7,
    y2: 7,
    transform: "translate(22 42)",
    fill: "none",
    stroke: "#9399b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoOptions, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-options.7caad88e.svg";
export { ForwardRef as ReactComponent };